/**
 * Returns all currently displayed row data (after filter/sort).
 * Uses AG Grid 34 API; getModel() was removed in favour of getDisplayedRowCount/getDisplayedRowAtIndex.
 * Defensive: returns [] if api is missing or methods unavailable (e.g. detail grid, or grid not ready).
 */
export const getAllRows = <T = any>(api: unknown): T[] => {
  if (!api || typeof api !== 'object') return [];
  const gridApi = api as {
    getDisplayedRowCount?: () => number;
    getDisplayedRowAtIndex?: (index: number) => { data: T } | null;
    forEachNode?: (callback: (node: { data?: T }) => void) => void;
  };
  try {
    if (typeof gridApi.getDisplayedRowCount === 'function' && typeof gridApi.getDisplayedRowAtIndex === 'function') {
      const count = gridApi.getDisplayedRowCount();
      const rows: T[] = [];
      for (let i = 0; i < count; i++) {
        const node = gridApi.getDisplayedRowAtIndex(i);
        if (node?.data) rows.push(node.data);
      }
      return rows;
    }
    const rows: T[] = [];
    if (typeof gridApi.forEachNode === 'function') {
      gridApi.forEachNode((node: { data?: T }) => {
        if (node.data) rows.push(node.data);
      });
    }
    return rows;
  } catch {
    return [];
  }
};
